import React from "react"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"
 
const SEO = ({
  lang,
  title,
  description,
  ogTitle,
  ogDescription,
  ogImage,
  disallowZoom = false
}) => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
          }
        }
      }
    `
  )

  const metaDescription = description || site.siteMetadata.description
  const facebookTitle = ogTitle || title;
  const facebookDescription = ogDescription || metaDescription; 
  const defaultTitle = site.siteMetadata?.title
  const metaZoom = disallowZoom ? { name: 'viewport', content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no' } : {}

  return (
    <Helmet
      htmlAttributes={{
        lang: lang || 'en',
      }}
      title={title}
      titleTemplate={defaultTitle ? `%s | ${defaultTitle}` : null}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: facebookTitle,
        },
        {
          property: `og:description`,
          content: facebookDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          property: `og:image`,
          content: ogImage,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
        {...metaZoom}
      ]}
    />
  )
}
 
 export default SEO